var Aneox;
(function (Aneox) {
  'use strict';

  var App = (function () {

    var pageWrapper;
    var firstLocalChange = true;

    function App(fonts, locale, router, analytics, wines, vintages, distributors, galleries, menu) {
      this.fonts = fonts;
      this.locale = locale;
      this.router = router;
      this.analytics = analytics;

      this.wines = wines;
      this.vintages = vintages;
      this.distributors = distributors;
      this.galleries = galleries;

      this.menu = menu;

      this.pageChangeFromScroll = false;


      var self = this;
      self.dataVintages = [];
      self.dataWhiteWines;
      self.dataRedWines;
      self.dataCountries;
      self.dataImport;
      self.dateGaleriePresentation;
      self.dataGalerieSavoirfaire;
      self.dataGalerie = [];    
      self.dataAllWines = [];
      self.dataAllWinesRaw = {}; 

      self.getUrlMillesime = "http://"+ window.location.host +"/chavy-chouet.com/api/views/liste_millesimes?display_id=services_1";    
      self.getUrlPays = "http://"+ window.location.host +"/chavy-chouet.com/api/views/liste_continents_pays?display_id=services_1";    
      self.getUrlWhiteWine = "http://"+ window.location.host +"/chavy-chouet.com/api/views/liste_vins_blanc?display_id=services_1";    
      self.getUrlRedWine = "http://"+ window.location.host +"/chavy-chouet.com/api/views/liste_vins_rouge?display_id=services_1";    
      self.getUrlImport = "http://"+ window.location.host +"/chavy-chouet.com/api/views/liste_importateurs?display_id=services_1";    
      self.getUrlGalerieSavoir = "http://"+ window.location.host +"/chavy-chouet.com/api/views/galerie_savoir_faire?display_id=services_1";    
      self.getUrlGaleriePresentation = "http://"+ window.location.host +"/chavy-chouet.com/api/views/galerie_presentation?display_id=services_1";    

      var md = new MobileDetect(window.navigator.userAgent);
      Aneox.Data.Config.runtime = {
        isTouchDevice: 'ontouchstart' in document.documentElement,
        mobile: md.mobile(),
        supportsScrollEvents: !md.mobile() || (md.is('iOS') && md.is('Safari') && md.version('Safari') > 8)
      };

      pageWrapper = $('#page-wrapper');

      var viewportWidth = $(window).width();
      var viewportHeight = $(window).height();
      
      // Quick and dirty desktop/mobile check
      if (screen && screen.availWidth >= 1024) window.location.href = 'http://www.chavy-chouet.com';
      
      if ($.cookie('agecheck') === 'true') {
        $('#age-check').remove();
        $('#page-wrapper').removeClass('noscroll');
      } else {
        $('#age-check').on('scroll', function(event) {
          event.stopPropagation();
        });
      }

      var now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      var nowText = now.toISOString().substring(0, 10).split('-');
      $('#age-check-date').text(nowText[2] + '/' + nowText[1] + '/' + nowText[0]);
      

      $(document).on("dataLoaded", initiate);     

      

      function setData(){

        self.vintages.setData(self.locale.getLocale());
        self.wines.renderLists(self.locale.getLocale());
        self.distributors.appendDataList(self.locale.getLocale());
        self.router.reparseAnchors();
      }
      
      function initiate(event){

        var tempDataWines = _.partition(self.dataAllWinesRaw, function(a){
          return a.nid == a.localeNid;
        });

        _.forEach(tempDataWines[0], function(wine){
          Aneox.Data.Nodes.nodes.push({
            id: wine.nid,
            type: 'wine-page',
            locales: [{
              locale: wine.locale,
              description: wine.name+' : '+wine.tasting,
              path: '/vins/' +  _.kebabCase(wine.name),
              title: 'Domaine Chavy-Chouet : '+ wine.name
            }]
          });
        });

        _.forEach(tempDataWines[1], function(wine){
          var node = _.find(Aneox.Data.Nodes.nodes,{'id': wine.localeNid});

          if(!_.isEmpty(node)){
            node.locales.push({
              locale: wine.locale,
              description: wine.name+' : '+wine.tasting,
              path: '/wines/' + _.kebabCase(wine.name),
              title: 'Domaine Chavy-Chouet : '+ wine.name
            }); 
          }
        });      

        setData();

        self.router.init();

        var throttledWindowResizeHandler = _.throttle(handleWindowResize, 500, { leading: false, trailing: true });
        $(window).resize(throttledWindowResizeHandler);
      //Visibility.change(throttledWindowResizeHandler);
      //self.fonts.bind('fontsActive', handleWindowResize);
      handleWindowResize();
      
      setTimeout(function () { $('#preloader').remove(); }, 1000);
      
      
    }



    this.router.bind('pageChange', function (path, node, nodeLocale) {
      self.locale.setLocale(nodeLocale.locale);
      var scrollTop;

      setTimeout(function() {
        $('[router-locale]').removeClass('active')
        .filter('[router-locale=' + nodeLocale.locale + ']').addClass('active');
      }, 1000);

      switch (node.type) {
        case 'wine-page':
              console.log("wine-page");
        self.wines.openPage(node.id);
        break;
        case 'legal':
        showLegal();
        case 'basic-page':
        if (node.id === 'home') {
          scrollTop = 0;
        } else {
          scrollTop = $('#' + node.id).offset().top;
        }
        pageWrapper.scrollTop(scrollTop);
        self.menu.update(node.id);
        default:


        var updatePage = function(sectionId) { 
          var section = $('#' + sectionId);
          var top = section.offset().top;
          var bottom = top + section.innerHeight();

              // var scrollPosition = pageWrapper.scrollTop() + viewportHeight / 2;
              
              // if (top <= scrollPosition && bottom >= scrollPosition) {
                if (top <= 30 && bottom >= 30) {
                  self.menu.update(sectionId);
                  var newNode = self.router.getNode(sectionId);
                  var newNodeLocale = newNode.locales.filter(function(locale) {
                    return locale.locale === nodeLocale.locale;
                  })[0];
                  var nodePath = self.router.getNodePath(sectionId, newNodeLocale.locale);
                  window.history.replaceState({}, newNodeLocale.title, nodePath);

                  self.pageChangeFromScroll = true;
                  self.router.processPath(window.location, newNode, newNodeLocale);
                  return false;
                }
              };

              var sectionIds = [
              'home',
              'domain-presentation',
              'domain-philosophy',
              'savoir-faire-viticulture',
              'savoir-faire-vinification',
              'wines',
              'vintages',
              'distributors',
              'contact'
              ];

              /*pageWrapper.on('scroll', _.debounce(function (event) {
                _.forEach(sectionIds, updatePage);
              }, 100));*/
            }



        //setTimeout(function () { $('#preloader').remove(); }, 1000);

      });

    this.locale.bind('localeChange', function (locale) {

      (function() {
        if ($('#age-check').length < 1) return;
        var now = new Date();
        now.setFullYear(now.getFullYear() - 18);
        var nowText = now.toISOString().substring(0, 10).split('-');
        $('#age-check-date').text(nowText[2] + '/' + nowText[1] + '/' + nowText[0]);
      }) ();

      $('[router-locale]').removeClass('active')
      .filter('[router-locale=' + locale + ']').addClass('active');

      firstLocalChange === true ? firstLocalChange = false : setData() ;

    });

     // Window resize handling
     var handleWindowResize = function() {
      var screenWidth = _.get(window, 'screen.width', 0);
      var screenHeight = _.get(window, 'screen.height', 0);
      var maxScreenSize = Math.max(screenWidth, screenHeight);
      var screenOrientation = _.get(window, 'orientation', 0);
      var isLandscape = screenOrientation === 90 || screenOrientation === -90;

      if (Aneox.Data.Config.runtime.mobile && isLandscape && screenHeight > 768) {
        window.location.href = window.location.host.indexOf('chavy-chouet.com') === -1 ? '/chavy-chouet.com/' : 'http://www.chavy-chouet.com/';
      }

        //if (currentController && currentController.handleWindowResize) currentController.handleWindowResize.call(currentController);
      };


      var getData = function(){
        var basePath = $('head base').attr('href');

        $.get(self.getUrlMillesime, function(data){

          var tmpDataVintages = data.map(function(a){
            return{
              "nid": a.nid,
              "vintages": a.vintages,
              "summary": a.summary,
              "text": a.text,
              "img": a.img,
              "imgpdf": a.imgpdf,
              "localeNid": a.localenid,
              "locale": a.locale
            }
          });


          tmpDataVintages.forEach(function(vintage){

            if(vintage.locale == "fr"){
              var currentVintage  = vintage;

              var enVintage = _.find(tmpDataVintages, function(el){
                if(el.localeNid == vintage.nid && el.nid != vintage.nid){
                  return el;
                }
              });

              self.dataVintages.push({id: currentVintage.nid, name: currentVintage.vintages,img: currentVintage.img, imgpdf: currentVintage.imgpdf , locales: [currentVintage,enVintage]})
            }

          });


          $.get(self.getUrlWhiteWine, function(data){

            self.dataWhiteWines = data.map(function(a){
              return{
                "nid": a.nid,
                "name": a.name,
                "type": _.parseInt(a.type),
                "grape": a.grape,
                "density": a.density,
                "village": a.village,
                "ageing": a.ageing,
                "niveau": a.niveau,
                "tasting": a.tasting,
                "soil": a.soil,
                "surface": a.surface,
                "age": a.age,
                "img": a.img,
                "localeNid": a.localenid,
                "locale": a.locale,
                "cremant": a.cremant,
                "imgpdf": a.imgpdf
              }
            });

            $.get(self.getUrlRedWine, function(data){

              self.dataRedWines = data.map(function(a){

                return{
                  "nid": a.nid,
                  "name": a.name,
                  "type": _.parseInt(a.type),
                  "grape": a.grape,
                  "density": a.density,
                  "village": a.village,
                  "ageing": a.ageing,
                  "niveau": a.niveau,
                  "tasting": a.tasting,
                  "soil": a.soil,
                  "surface": a.surface,
                  "age": a.age,
                  "img": a.img,
                  "localeNid": a.localenid,
                  "locale": a.locale,
                  "cremant": a.cremant,
                  "imgpdf": a.imgpdf
                }
              });
              $.get(self.getUrlPays, function(data){

               self.dataCountries = data.map(function(a){
                return{
                  "name": a.name,
                  "tid": _.parseInt(a.tid),
                  "parentTid": _.parseInt(a.parent_tid),
                  "localeEn": a.localeen,
                  "img": a.img 
                }
              });

               $.get(self.getUrlImport, function(data){

                self.dataImport = data.map(function(a){
                  return{
                    "nid": a.nid,
                    "name": a.name,
                    "address": a.address,
                    "tel": a.tel,
                    "fax": a.fax,
                    "email": a.email,
                    "website": a.website,
                    "countries": _.parseInt(a.countries)
                  }
                });


                $.get(self.getUrlGalerieSavoir, function(data){


                  var dataGalerieSavoirfaire = data.map(function(a){
                    return{
                      "img": a.img
                    }
                  });

                  self.dataGalerie.push({id: "savoir-faire", slides: dataGalerieSavoirfaire});

                  $.get(self.getUrlGaleriePresentation, function(data){

                    var dataGaleriePresentation = data.map(function(a){
                      return{
                        "img": a.img
                      }
                    });

                    self.dataGalerie.push({id: "domain", slides: dataGaleriePresentation});

                    var tmpDataAllWines = _.uniq(_.union(self.dataRedWines, self.dataWhiteWines), "nid"); 

                    self.dataAllWinesRaw = tmpDataAllWines;

                    tmpDataAllWines.forEach(function(wine){

                      if(wine.locale == "fr"){
                                            //var currentWine = 
                                            
                                            //var enWine = _.find(tmpDataAllWines, {"localeNid": wine.nid});
                                            
                                            var enWine = _.find(tmpDataAllWines, function(el){
                                              if(el.localeNid == wine.nid && el.nid != wine.nid){
                                                return el;
                                              }
                                            });
                                            
                                            self.dataAllWines.push({id: wine.nid, name: wine.name,img: wine.img , locales: [wine,enWine]})
                                          }

                                        });

                    $(document).trigger('dataLoaded');

                  });

                });

              });
             });
            });
          });

});
}    


getData();


}

    // App.prototype.scrollDown = function() {
    //   var scrollDistance = $(window).height();
    //   var pageWrapper = document.getElementById('page-wrapper');
    //   animatedScrollTo(
    //     pageWrapper,
    //     $(pageWrapper).scrollTop() + scrollDistance,
    //     500
    //   );
    // };

    

    function showLegal() {
      $('#legal').fadeIn();
    };

    // App.prototype.hideLegal = function () {
    //   $('#legal').fadeOut();
    // };

    App.prototype.ageCheckResult = function (result) {
      if (!result) return;
      
      $.cookie('agecheck', 'true');
      $('#age-check').fadeOut();
      $('#page-wrapper').removeClass('noscroll');
      
      setTimeout(function () { $('#age-check').remove(); }, 500);
    }

    return App;
  })();

  Aneox.App = App;
})(Aneox || (Aneox = {}));